<template>
  <div class="col-xs-12 text-right">
    <nav class="pagination">
      <ul>
        <li style="display: inline" v-if="pagination.prevPageUrl">
          <a class="pagination__item" @click="changePage(pagination.prevPageUrl), decreaseX()">
            <i class="fa fa-angle-left" style="font-size: 30px; padding-right: 10px"></i>
          </a>
        </li>
        <li style="display: inline" v-else>
          <a class="disabled pagination__item">
            <i
              class="fa fa-angle-left"
              style="color: grey; font-size: 30px; padding-right: 10px"
            ></i>
          </a>
        </li>
        <li v-for="p in totalPages" :key="p" style="display: inline">
          <a
            :class="p + x === pagination.currentPage ? 'pagination__item1' : 'pagination__item'"
            :style="
              p + x === pagination.currentPage
                ? 'font-size: 24px; color: white'
                : 'font-size: 24px; color: #4caf50;'
            "
            @click="
              changePage(
                pagination.lastPageUrl
                  .substring(0, pagination.lastPageUrl.lastIndexOf('='))
                  .concat('=')
                  .concat(p + x)
              )
            "
          >
            {{ p + x }}
          </a>
        </li>
        <li v-if="pagination.nextPageUrl" style="display: inline">
          <a class="pagination__item" @click="changePage(pagination.nextPageUrl), increaseX()">
            <i class="fa fa-angle-right" style="font-size: 30px; padding-left: 10px"></i>
          </a>
        </li>
        <li v-else style="display: inline">
          <a class="disabled pagination__item">
            <i
              class="fa fa-angle-right"
              style="color: grey; font-size: 30px; padding-left: 10px"
            ></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: ['pagination', 'changePage'],

  data() {
    return {
      itemsPerPage: 3,
      x: 0
    }
  },

  methods: {
    decreaseX() {
      if (this.x !== 0) {
        this.x = this.x - 1
      }
    },

    increaseX() {
      if (this.x !== this.pagination.lastPage - this.totalPages) {
        this.x = this.x + 1
      }
    }
  },

  computed: {
    totalPages: function() {
      if (this.pagination.lastPage <= 5) {
        return this.pagination.lastPage
      } else {
        return (this.pagination.lastPage % (this.pagination.lastPage - 1)) + 4
      }
    },

    p: function() {
      return 1 + this.x
    }
  }
}
</script>

<style scoped>
a.disabled {
  pointer-events: none;
}
.pagination {
  justify-content: flex-end !important;
}
.pagination .page-stats {
  align-items: center;
  margin-right: 5px;
}
i {
  color: #4caf50;
}

.pagination__item1 {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: transparent;
  height: 34px;
  width: 34px;
  margin: 0.3rem;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
  background-color: #4caf50;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue